import * as types from '../constants';

export const initFloorListState = () => ({
  type: types.INIT_FLOOR_LIST_STATE,
});

export const setFloorList = floorList => ({
  type: types.SET_FLOOR_LIST,
  payload: floorList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_FLOOR_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_FLOOR_PAGINATION_ITEM,
  payload: paginationItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_FLOOR_FILTER_ITEM,
  payload: filterItem
});